/* eslint no-undef: "off" */
const config = SETTINGS

export default config
